import { Button, Col, Flex, Image, Row, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./ServiceProvider.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { GetCardLayout } from "../../../../common/getCardLayout";
import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../../../constants/routeConsts";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { dateObjToDispViewDate } from "../../../../../utils/utils";
import { getServiceProviderByIdAction } from "../../../../../redux/services/service-providers/serviceProvidersServices";
import { useTranslation } from "react-i18next";

const ServiceProviderDetailsDetails = () => {

  const {t} = useTranslation();
  
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const {
    selectedServiceProvider: { selectedServiceProviderId, navigateBack },
  } = useSelector((state) => state.serviceProviders);
  const [serviceProviderDetails, setServiceProviderDetails] = useState(null);

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedServiceProviderId &&
      selectedServiceProviderId !== "" &&
      selectedServiceProviderId !== null &&
      selectedServiceProviderId !== undefined
    ) {
      const dataToBeSent = {
        selectedServiceProviderId,
      };
      dispatch(getServiceProviderByIdAction(dataToBeSent, setLoading)).then(
        (apiRes) => {
          const response = apiRes;
          setServiceProviderDetails(response);
        }
      );
    }
  }, []);

  return (
    <div className={styles.serviceProviderDetailsContainer}>
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(navigateBack)}
          />
          <Typography.Title underline level={2}>
            {t("appointmentInfo.serviceProviderInfo")}
          </Typography.Title>
        </Flex>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.logoImage")}
              required={false}
            />
            {serviceProviderDetails?.logo_image ? (
              <Image
                style={{
                  width: "120px",
                  maxWidth: "100%",
                  border: "1px solid lightGray",
                  padding: "5px",
                  borderRadius: "10px",
                }}
                src={serviceProviderDetails?.logo_image ?? "-"}
                alt={t("appointmentInfo.logoImage")}
              />
            ) : (
              <>-</>
            )}
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.businessName")}
              required={false}
            />
            <div>{serviceProviderDetails?.name ?? ""}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.directorName")}
              required={false}
            />
            <div>{serviceProviderDetails?.director_name ?? ""}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.designation")}
              required={false}
            />
            <div>{serviceProviderDetails?.designation ?? ""}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.branch")}
              required={false}
            />
            <div>{serviceProviderDetails?.branch ?? ""}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("appointmentInfo.email")} required={false} />
            <div>{serviceProviderDetails?.owner?.email ?? ""}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.phoneNumber")}
              required={false}
            />
            <div>{`+${
              serviceProviderDetails?.owner?.phone?.country_code ?? ""
            } ${
              serviceProviderDetails?.owner?.phone?.phone_number ?? ""
            }`}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("ProfileSetup.countryLabel")} required={false} />
            <div>{serviceProviderDetails?.address?.country?.name || "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("appointmentInfo.city")} required={false} />
            <div>{serviceProviderDetails?.address?.city?.name ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("appointmentInfo.state")} required={false} />
            <div>{serviceProviderDetails?.address?.state?.name ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.zipCode")}
              required={false}
            />
            <div>{serviceProviderDetails?.address?.zip_code ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.planExpiryDate")}
              required={false}
            />
            <div>
              {dateObjToDispViewDate(
                serviceProviderDetails?.plan_expiry_date,
                "ddmmyyyy"
              ) ?? "-"}
            </div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.freeUsersAllowed")}
              required={false}
            />
            <div>{serviceProviderDetails?.free_users_allowed ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.paidUsersCreated")}
              required={false}
            />
            <div>{serviceProviderDetails?.paid_users_created ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("appointmentInfo.organizationVerified")}
              required={false}
            />
            <Tag
              color={
                serviceProviderDetails?.organization_verified ? "green" : "red"
              }
            >
              {serviceProviderDetails?.organization_verified
                ? t("appointmentInfo.verified")
                : t("appointmentInfo.notVerified") ?? "-"}
            </Tag>
          </Col>
          <Col span={24}>
            <RequiredLabel
              text={t("appointmentInfo.payoutDetails")}
              required={false}
            />
            <div
              style={{
                border: "1px solid lightGray",
                padding: "10px",
                borderRadius: "8px",
                marginTop: "8px",
              }}
            >
              <div>
                <strong>{t("appointmentInfo.accountHolderName")}:</strong>{" "}
                {serviceProviderDetails?.payout_details?.account_holder_name ??
                  "-"}
              </div>
              <div>
                <strong>{t("appointmentInfo.accountNumber")}:</strong>{" "}
                {serviceProviderDetails?.payout_details?.account_number ?? "-"}
              </div>
              <div>
                <strong>{t("appointmentInfo.bankCode")}:</strong>{" "}
                {serviceProviderDetails?.payout_details?.bank_code ?? "-"}
              </div>
              <div>
                <strong>{t("appointmentInfo.swiftCode")}:</strong>{" "}
                {serviceProviderDetails?.payout_details?.swift_code ?? "-"}
              </div>
              <div>
                <strong>{t("appointmentInfo.bankName")}:</strong>{" "}
                {serviceProviderDetails?.payout_details?.bank_name ?? "-"}
              </div>
            </div>
          </Col>
        </Row>
      </Flex>
    </div>
  );
};

export default ServiceProviderDetailsDetails;
